export class WhatsappUtility {
    static toWaNumber(raw: string | null | undefined, country = '51'): string {
        const digits = (raw ?? '').replace(/\D/g, '');
        if (!digits) {
            return '';
        }
        if (digits.startsWith(country) && digits.length === country.length + 9) {
            return digits;
        }
        if (digits.length === 9) {
            return country + digits;
        }
        return digits;
    }

    static waLink(raw: string | null | undefined, text: string): string {
        const to = WhatsappUtility.toWaNumber(raw);
        if (!to || !text) {
            return '';
        }
        return `https://wa.me/${to}?text=${encodeURIComponent(text)}`;
    }
}
